import { GridEditInputCell, GridRenderEditCellParams } from "@mui/x-data-grid";
import { StyledTooltip } from "../styles";
import React from "react";

function createTooltipInputCell(
  props: GridRenderEditCellParams,
  error: string | null
) {
  return (
    <StyledTooltip open={!!error} title={error || ""}>
      <GridEditInputCell {...props} />
    </StyledTooltip>
  );
}

export function renderEditInputCell(
  params: GridRenderEditCellParams,
  error: string | null
) {
  return createTooltipInputCell(params, error);
}
